import { render, staticRenderFns } from "./IndexPageIssue.vue?vue&type=template&id=07a8193a"
import script from "./IndexPageIssue.vue?vue&type=script&lang=js"
export * from "./IndexPageIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports